<template>
  <window-default ref="window" :resolve="find" :proccessData="proccessData" :mock="mock" :props="props" v-slot="{data}" @loaded="(obj) => model = obj" @save="save">
    <window-body class="wrapper-lg">
      <e-row mr>
        <e-col size="1">
          <erp-s-field
              label="ID:"
            >
            <erp-input v-model="model.id" size="2" readonly />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Nome:"
          >
            <erp-input autofocus v-model="model.nome" size="2" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Código Único:"
          >
            <erp-input autofocus v-model="model.codigo" size="2" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Descrição:"
          >
            <erp-input autofocus v-model="model.descricao" size="2" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Ativo:"
          >
            <erp-checkbox v-model="model.active" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col class="font-10 text-blue-grey-6 m-t-n-xs">
          Marque o campo acima se este acessório deve aparecer em qualquer tipo de bem do sistema
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field
              label="Status relacionado(s):"
          >
            <erp-select multiple v-model="model.status" placeholder="Nenhum" :options="tiposFiltered"
                        :loading="loadingTipos" size="2">
              <template v-slot:itemLabel="props">
                <span class="erp-select-level" :class="{'font-bold': Number(props.opt.level) === 0}" :style="'padding: 0 0 0 ' + (10 * Number(props.opt.level)) + 'px' ">{{props.opt.label}}</span>
              </template>
            </erp-select>
          </erp-s-field>
        </e-col>
      </e-row>

    </window-body>
  </window-default>
</template>

<script>
import {WindowBody, ErpSField, ErpInput, ErpCheckbox, ErpSelect} from 'uloc-vue-plugin-erp'
import WindowDefault from '../../../../../reuse/window/Default'
import ERow from '../../../../layout/components/Row'
import ECol from '../../../../layout/components/Col'
import {
  findClassificacaoProcesso as find,
  listStatusProcessos,
  newClassificacaoProcesso as _new,
  updateClassificacaoProcesso as update
} from '../../../../../domain/cadastro/services'
import save from '../../../helpers/save'
import {treeCheck} from '../../tiposbem/helpers/treeCheck'

let mock = {
  id: null,
  nome: null,
  codigo: null,
  descricao: null,
  active: true,
  status: []
}

export default {
  name: 'ClassificacaoProcessoWindow',
  components: {ECol, ERow, WindowDefault, WindowBody, ErpSField, ErpInput, ErpCheckbox, ErpSelect},
  props: ['props'],
  data () {
    return {
      model: JSON.parse(JSON.stringify(mock)),
      loadingTipos: false,
      tipos: []
    }
  },
  mounted () {
    listStatusProcessos(200, 1, null, true)
      .then(({data}) => {
        this.tipos = data
        this.loadingTipos = false
      })
      .catch(error => {
        console.error(error)
      })
  },
  computed: {
    find () {
      return find
    },
    mock () {
      return mock
    },
    tiposFiltered () {
      return this.treeCheck(this.tipos)
    }
  },
  methods: {
    update: update,
    new: _new,
    save: save,
    proccessData (data) {
      let _mock = JSON.parse(JSON.stringify(this.mock))
      data = Object.assign(_mock, data)

      if (data.status && Array.isArray(data.status)) {
        data.status = data.status.map(tipo => {
          return tipo.id
        })
      }
      console.log(data)
      return data
    },
    treeCheck: treeCheck
  }
}
</script>
